<input
  (blur)="propagateTouch(searchInput)"
  (keydown.tab)="onTab($event)"
  (selectItem)="onSelected($event)"
  [(ngModel)]="model"
  [autofocus]="true"
  [inputFormatter]="inputFormatter"
  [ngbTypeahead]="search"
  [resultFormatter]="resultFormatter"
  #searchInput
  class="form-control typeahead-input"
  type="search" />
